module.exports = __webpack_public_path__ + "static/logo-e05ecf5c27a037181ab560c61008dac8.svg";